import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {Translate, SecureFileGrid} from 'views/module';

const ProfileView = (props) => {
  const {bioQuestions, setIsComplete} = props;

  const {
    shortBio,
    personalBio,
    caregiverMotivation,
    profilePhoto = [],
  } = bioQuestions;

  React.useEffect(() => {
    const requiredFields = [
      'shortBio',
      'personalBio',
      'caregiverMotivation',
      'profilePhoto',
    ];
    const isComplete = requiredFields.every(
        (field) => bioQuestions[field] && String(bioQuestions[field]).trim() !== '',
    );
    const hasPicture = profilePhoto.length;
    setIsComplete(isComplete && hasPicture > 0);
  }, [bioQuestions]);

  return (
    <Stack spacing={2} alignItems="flex-start">
      <Stack spacing={0}>
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression='caregiver.CaregiverBiography.Profile.ShortBio'/>
        </Typography>
        <Typography sx={{whiteSpace: 'pre-line'}}>
          {
            shortBio ||
            <Translate expression='caregiver.CaregiverBiography.Profile.Missing.ShortBio' />
          }
        </Typography>
      </Stack>

      <Stack spacing={0}>
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression='caregiver.CaregiverBiography.Profile.PersonalBio'/>
        </Typography>
        <Typography sx={{whiteSpace: 'pre-line'}}>
          {
            personalBio ||
            <Translate expression='caregiver.CaregiverBiography.Profile.Missing.PersonalBio' />
          }
        </Typography>
      </Stack>

      <Stack spacing={0}>
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression='caregiver.CaregiverBiography.Profile.CaregiverMotivation'/>
        </Typography>
        <Typography sx={{whiteSpace: 'pre-line'}}>
          {
            caregiverMotivation ||
            <Translate expression='caregiver.CaregiverBiography.Profile.Missing.CaregiverMotivation' />
          }
        </Typography>
      </Stack>

      <Stack spacing={0}>
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression='caregiver.CaregiverBiography.Profile.ProfilePhoto'/>
        </Typography>
        {
          profilePhoto.length === 0 &&
          <Typography sx={{whiteSpace: 'pre-line'}}>
            <Translate expression='caregiver.CaregiverBiography.Profile.Missing.ProfilePhoto' />
          </Typography>
        }
        {
          profilePhoto.length > 0 &&
          <SecureFileGrid
            files={profilePhoto}
          />
        }
      </Stack>
    </Stack>
  );
};

ProfileView.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  setIsComplete: PropTypes.func.isRequired,
};

export default React.memo(ProfileView);
